import axios from '@/utils/axios';
import urlConfig from '@/utils/urlConfig';


export default {

    /**
     * /consign/summary
     * 代销-结算汇总单
     */
    // 汇总生成 (310907)
    summaryGenerateApi: (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/generate', data),
    // 作废 (310908)
    summaryDeleteApi:  (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/delete', data),
    // 列表分页 (310909)
    summaryPageApi:    (data) => axios.apiPost(
        urlConfig.busiURL + '/consign/summary/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data
    ),
    // 详情 (310910)
    summaryDetailApi:  (summaryNo) => axios.apiGet(
        urlConfig.busiURL + '/consign/summary/detail?summaryNo=' + summaryNo
    ),
    // 来账匹配 (310911)
    summaryMatchApi:   (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/match', data),
    // 批量匹配（勾选流水 + 部分金额）
    summaryBatchMatchApi: (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/match/batch', data),
    // 银行流水查询 (230907 detailQuery)
    payFlowListApi:    (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/pay-flow/list', data),
    // 清算还款 (310912)
    summaryRepayApi:   (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/repay', data),
    // 重试同步银行 (310907 重推，仅 syncStatus='0'/'2' 允许)
    summarySyncRetryApi: (data) => axios.apiPost(urlConfig.busiURL + '/consign/summary/sync/bank', data),
    // 修正记录分页（busi_collect_settle_orders_revision，按 summaryNo 查同步历史）
    summaryRevisionPageApi: (data) => axios.apiPost(
        urlConfig.busiURL + '/consign/summary/revision/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data
    ),
    // 关联原始结算单明细分页（按 summaryNo 查 busi_original_settle_order，避免一次性返回几千上万条）
    summaryItemsPageApi: (data) => axios.apiPost(
        urlConfig.busiURL + '/consign/summary/items/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data
    ),



    /**
     * /consign/originalSettleOrder
     * 代销-原始结算单查询（纯查询,无新增编辑）
     */
    // 分页
    originalSettleOrderPageApi: (data) => axios.apiPost(
        urlConfig.busiURL + '/consign/originalSettleOrder/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data
    ),
    // 详情
    originalSettleOrderDetailApi: (orderNo) => axios.apiGet(
        urlConfig.busiURL + '/consign/originalSettleOrder/detail?orderNo=' + orderNo
    ),


    /**
     * /consign/contract
     * 代销-合同管理
     */
    // 草稿保存
    contractSaveApi:    (data) => axios.apiPost(urlConfig.busiURL + '/consign/contract/save', data),

    // 提交审批
    contractSubmitApi:  (contractNo) => axios.apiPost(
        urlConfig.busiURL + '/consign/contract/submit?contractNo=' + contractNo
    ),
    // 审批 (310807)
    contractApproveApi: (data) => axios.apiPost(urlConfig.busiURL + '/consign/contract/approve', data),
    // 重新同步 (310807)
    contractSyncApi:    (contractNo) => axios.apiPost(
        urlConfig.busiURL + '/consign/contract/sync?contractNo=' + contractNo
    ),
    // 作废 (310808)
    contractInvalidApi: (contractNo) => axios.apiPost(
        urlConfig.busiURL + '/consign/contract/invalid?contractNo=' + contractNo
    ),
    // 列表分页
    contractPageApi:    (data) => axios.apiPost(
        urlConfig.busiURL + '/consign/contract/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data
    ),
    // 详情
    contractDetailApi:  (contractNo) => axios.apiGet(
        urlConfig.busiURL + '/consign/contract/detail?contractNo=' + contractNo
    ),

};
